export const setState = (state, action, key) => {
  return {
    ...state,
    [key]: action[key],
  };
};

export  const resetState = (state, key) => {
  return {
    ...state,
    [key]: null,
  };
};

export const setObjectToState = (state, obj) => ({
  ...state,
  ...obj,
});

export const appendItemToStateArray = (state, action, arrayKey) => {
  const newArray = appendItemToArray(state[arrayKey], action.newItem);
  return setState(state, {[arrayKey]: newArray}, arrayKey);
};

export const deleteItemToStateArray = (state, action, arrayKey) => {
  const index = state[arrayKey].findIndex(action.findFunction);
  if(index >= 0){
    const newArray = removeItemFromArray(state[arrayKey], index);
    return setState(state, {[arrayKey]: newArray}, arrayKey);
  }
  return state;
};

export const appendItemToArray = (array, newItem) => [...array, newItem];

export const removeItemFromArray = (array, index) => [...array.slice(0, index), ...array.slice(index + 1)];

export const updateItemInArray = (array, newItem, index) => [
  ...array.slice(0, index),
  newItem,
  ...array.slice(index + 1),
];



// WEBPACK FOOTER //
// ./src/reducers/helper.js